import Model from "../Model";

class Analitycs extends Model{

    buildUrl ({ param }) {
        return ['/analytics/getbyuser', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new Analitycs;